import { T } from '../lib/i18n'
interface LogoProps {
  compact?: boolean
  inverse?: boolean
}

export function Logo({ compact = false, inverse = false }: LogoProps) {
  return (
    <div className={`brand-lockup ${compact ? 'brand-lockup--compact' : ''} ${inverse ? 'brand-lockup--inverse' : ''}`}>
      <img className="brand-mark" src="/brand-mark.png" alt="" />
      {!compact && (
        <div>
          <strong><T>{"TidyPing"}</T></strong>
          <span><T>{"Cleaning, coordinated."}</T></span>
        </div>
      )}
    </div>
  )
}
